<div class="library-dialog">
  @if (editMode) {
  <h2 mat-dialog-title i18n>Edit Directory</h2>
  } @if (!editMode) {
  <h2 mat-dialog-title i18n>Enter New Directory</h2>
  }

  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="dialog-fields">
        @if (data.type === LibraryT.PUBLIC ) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@directory">Parent Directory</mat-label>
          <mat-select formControlName="parentUuid">
            <mat-option [value]="null">.</mat-option>
            @for (parent of (directories$ | async); track parent) {
            <mat-option [value]="parent.uuid">{{ parent.name }}</mat-option>
            }
          </mat-select>
          <button type="button" matSuffix matIconButton aria-label="Clear parent directory"
            (click)="form.controls.parentUuid.setValue(null); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        } @if (data.type === LibraryT.PERSONAL ) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n="@@personalFolder">Personal Folder</mat-label>
          <mat-select
            formControlName="relatedObjectUuid"
            (selectionChange)="onPersonalFolderChange($event)"
          >
            <mat-option [value]="null">.</mat-option>
            @for (srvmen of (usersService.servicemen$| async); track srvmen) {
            <mat-option [value]="srvmen.uuid">{{ srvmen.name }}</mat-option>
            }
          </mat-select>
          <button type="button" matSuffix matIconButton aria-label="Clear personal folder"
            (click)="form.controls.relatedObjectUuid.setValue(null); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        }
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n>External Id (opt.)</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="filled"
        color="accent"
        (click)="onSave()"
        [disabled]="!form.valid"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </mat-dialog-actions>
</div>
